import type { SheetOrigin } from "@/excel/speckle/receiveTypes";

const EXCEL_WORKSHEET_MAX_ROWS = 1_048_576;
const EXCEL_WORKSHEET_MAX_COLUMNS = 16_384;
const RECEIVE_OUTPUT_MAX_ROWS = 20_000;
const RECEIVE_OUTPUT_MAX_CELLS = 160_000;

function isNonEmptyCell(value: unknown): boolean {
  if (value === null || value === undefined) {
    return false;
  }

  if (typeof value === "string") {
    return value.trim() !== "";
  }

  return true;
}

export function countNonEmptyCells(values: unknown[][]): number {
  return values.reduce((count, row) => count + row.filter(isNonEmptyCell).length, 0);
}

export function assertReceiveOutputSize(rowCount: number, columnCount: number): void {
  if (rowCount > RECEIVE_OUTPUT_MAX_ROWS) {
    throw new Error(
      `Receive output is too large. It contains ${rowCount} rows, but the current limit is ${RECEIVE_OUTPUT_MAX_ROWS}.`
    );
  }

  const cellCount = rowCount * columnCount;

  if (cellCount > RECEIVE_OUTPUT_MAX_CELLS) {
    throw new Error(
      `Receive output is too large. It contains ${cellCount} cells, but the current limit is ${RECEIVE_OUTPUT_MAX_CELLS}.`
    );
  }
}

export function assertTargetFitsWorksheet(origin: SheetOrigin, rowCount: number, columnCount: number): void {
  const { startRow, startColumn } = origin;

  if (startRow + rowCount > EXCEL_WORKSHEET_MAX_ROWS) {
    throw new Error("Receive output does not fit below the selected cell. Select a cell higher in the worksheet.");
  }

  if (startColumn + columnCount > EXCEL_WORKSHEET_MAX_COLUMNS) {
    throw new Error("Receive output does not fit to the right of the selected cell. Select a cell further left.");
  }
}
